import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function LocationMaster(props) {
  const [locations, setLocations] = useState([]);
  const [locationCode, setLocationCode] = useState('');
  const [locationName, setLocationName] = useState('');
  const [formMode, setFormMode] = useState('add');
  const [editLocationCode, setEditLocationCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [locationMasterEntries, setLocationMasterEntries] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    fetchLocationMaster();
  }, []);

  const fetchLocationMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/locations');
      setLocationMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setLocationCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
    if (entry.LocationCode > maxEntryNo) {
    maxEntryNo = entry.LocationCode;
    }
    }
    return maxEntryNo;
  };

  const addLocation = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/locations', {
        LocationCode: locationCode,
        LocationName: locationName,
        USERID: props.name
      });
      fetchLocationMaster();
      setLocationCode('');
      setLocationName('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateLocation = async (LocationCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/locations/${LocationCode}`, {
        LocationCode: locationCode,
        LocationName: locationName,
        USERID: props.name
      });
      fetchLocationMaster();
      setLocationCode('');
      setLocationName('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteLocation = async (LocationCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/locations/${LocationCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchLocationMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };  


  const setEditForm = (location) => {
    setFormMode('edit');
    setLocationCode(location.LocationCode);
    setLocationName(location.LocationName);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = locations.filter((location) => {
      const LocationCode = location.LocationCode.toString().toLowerCase();
      const LocationName = location.LocationName.toString().toLowerCase();

      return (
        LocationCode.includes(searchQuery.toLowerCase()) ||
        LocationName.includes(searchQuery.toLowerCase())
      );
    });

    setLocationMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, locations]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setLocations(locations);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditLocationCode('');
    setLocationCode('');
    setLocationName('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "LocationData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>LocationMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="locationCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>LocationCode</label>
            <input
              type="text"
              id="locationCode"
              value={locationCode}
              onChange={(e) => setLocationCode(e.target.value)}
              placeholder="LocationCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="locationName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>LocationName</label>
            <input
              type="text"
              id="locationName"
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
              placeholder="LocationName"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addLocation : () => updateLocation(locationCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  LocationCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  LocationName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {locationMasterEntries.map((location) => (
                <tr key={location.LocationCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{location.LocationCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{location.LocationName}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(location)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteLocation(location.LocationCode)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default LocationMaster;
